import { cn, taskStatus } from "@/lib/utils";
import { Handle, Position } from "@xyflow/react";
import { memo, useState } from "react";
import { ChevronRight, ChevronLeft, ChevronUp, ChevronDown } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger, TooltipTrigger, Tooltip, TooltipProvider, TooltipContent} from "@/components/ui";
import { TaskTooltipContent } from "@/components";
import { useIsMobile } from "@/hooks/use-mobile";

const Node = ({data, isConnectable, parentId, targetPosition, sourcePosition, onOpenPopover, isMobile}: any) => {
  return (
    <div className={cn("p-2 rounded-sm bg-white border-1 w-[150px]", taskStatus[data?.actualStatus?.toLowerCase()]?.className)}>
      <div className={cn("text-[14px] font-normal", isMobile ? "cursor-pointer" : "")} onClick={onOpenPopover}>{data.label}</div>

      {parentId ? <Handle
        type="target"
        position={targetPosition || Position.Left}
        className="w-16 pointer-none bg-none border-0"
        style={{
          background: 'none',
          border: 'none',
        }}
        isConnectable={isConnectable}
      >
        {targetPosition == Position.Top ? 
          <ChevronDown className="h-5 w-5 -mt-[10px] -ml-[7px]" /> : 
          targetPosition == Position.Bottom ? 
            <ChevronUp className="h-5 w-5 -mt-[5px] -ml-[7px]" /> : 
              targetPosition == Position.Right ? 
                <ChevronLeft className="h-5 w-5 -mt-[7px] -ml-[5px]" /> : 
                <ChevronRight className="h-5 w-5 -mt-[7px] -ml-[10px]" />
        }
      </Handle>: <></>}
      {data?.children?.length ? <Handle
        type="source"
        position={sourcePosition || Position.Right}
        className="w-16"
        isConnectable={isConnectable}
      /> : <></>}
    </div>
  )
}

const CustomNode = (props: any) => {
  const { data } = props;
  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return isMobile ? 
    <TooltipProvider>
      <Tooltip open={isOpen}>
        <TooltipTrigger className="mx-1" type="button">
          <Node {...props} onOpenPopover={() => setIsOpen(true)} />
        </TooltipTrigger>
        <TooltipContent 
          onPointerDownOutside={(e) => {
            e.stopPropagation();
            setIsOpen(false)
          }} 
          className={cn(taskStatus[data?.actualStatus?.toLowerCase()]?.className, "w-[240px] pointer-events-auto shadow-md rounded-xl")}>
          <TaskTooltipContent task={data} />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
     : (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div>
          <Node {...props} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent 
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        className={cn(taskStatus[data?.actualStatus?.toLowerCase()]?.className, "w-[240px] pointer-events-auto shadow-md rounded-xl")}>
          <TaskTooltipContent task={data} />
      </HoverCardContent>
    </HoverCard>
  );
}
 
export default memo(CustomNode);
